import { render } from "./MyAffiliate.vue?vue&type=template&id=553cd730&scoped=true"
import script from "./MyAffiliate.vue?vue&type=script&lang=js"
export * from "./MyAffiliate.vue?vue&type=script&lang=js"

import "./MyAffiliate.vue?vue&type=style&index=0&id=553cd730&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-553cd730"]])

export default __exports__